<template>
  <div>
    <div class="operations is-flex is-align-items-center">
      <a
        v-if="show_edit"
        @mouseleave="makeEvent({ event_name: 'edit_leave', event_data: payload })"
        @mouseover="makeEvent({ event_name: 'edit_hover', event_data: payload })"
        @click="makeEvent({ event_name: 'edit_click', event_data: payload})"
        class="edit-btn button is-info is-outlined"
      >
        Edit
      </a>
      <a
        v-if="show_delete"
        @click="makeEvent({ event_name: 'delete', event_data: payload })"
        class="delete-btn button is-danger is-outlined"
        >Delete</a
      >
      <div
        class="operation_icon"
        :key="operation.name"
        v-for="operation in operations"
      >
        <div
          v-if="operation.component == undefined"
        >
          <img
            class="operation_icon"
            v-if="operation.icon != undefined"
            :src="operation.icon"
            :title="operation.title"
            @click.self="makeEvent({ event_name: operation.name.toLowerCase(), event_data: payload })"
            @mouseleave.self="makeEvent({ event_name: `${operation.name.toLowerCase()}_leave`, event_data: payload })"
            @mouseover.self="makeEvent({ event_name: `${operation.name.toLowerCase()}_hover`, event_data: payload })"
          />
          <a
            v-else
            class="button is-info is-outlined"
            style="color: black;"
            @click.self="makeEvent({ event_name: operation.name.toLowerCase(), event_data: payload })"
            @mouseleave.self="makeEvent({ event_name: `${operation.name.toLowerCase()}_leave`, event_data: payload })"
            @mouseover.self="makeEvent({ event_name: `${operation.name.toLowerCase()}_hover`, event_data: payload })"
          >
            {{ operation.title || operation.name }}
          </a>
        </div>
        <div v-else>
          <component
            :is="operation.component"
            :additional_data="operation.additional_data"
            :payload="getComponentData(operation.component_data_path)"
            :data="payload"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPropertyFromPathSafely } from '@/custom/classes/my_utils.js'
import ExtraAttributes from '@/components/ExtraAttributes'
import IsStar from '@/components/IsStar'
import IsWatch from '@/components/IsWatch'
import CompletenessIndicator from '@/components/CompletenessIndicator'
import Preview from '@/components/Preview'
import AlertButton from '@/components/AlertButton'
import BoosterButton from '@/components/BoosterButton'
import ButtonEvaluate from '@/components/ButtonEvaluate'
import OfferConversationButton from '@/components/OfferConversationButton'
import IsHot from '@/components/IsHot'
import CompanySuitcase from '@/components/CompanySuitcase'

import FeedOffer from '@/components/FeedOffer'
import PreviewCompanyInPanel from '@/components/PreviewCompanyInPanel'
import OfferWhatsAppLink from '@/components/OfferWhatsAppLink'
import PhoneCallButton from '@/components/PhoneCallButton'
import AlertDoneButton from '@/components/AlertDoneButton'
import AlertPlusMinusButton from '@/components/AlertPlusMinusButton'
import OperationScore from '@/components/positions/offers/OperationScore'

export default {
  name: 'operations',
  props: {
    show_edit: {
      type: Boolean,
      default: false
    },
    show_delete: {
      type: Boolean,
      default: true
    },
    operations: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => {}
    },
    payload: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getComponentData (component_data_path) {
      if (component_data_path == undefined) {
        return this.payload
      }
      return getPropertyFromPathSafely({ context: this.payload, path: component_data_path })
    },
    makeEvent (params) {
      this.$emit('operation_clicked', params)
    }
  },
  components: {
    ExtraAttributes,
    IsStar,
    IsWatch,
    CompletenessIndicator,
    Preview,
    OperationScore,
    AlertButton,
    BoosterButton,
    ButtonEvaluate,
    OfferConversationButton,
    CompanySuitcase,
    IsHot,
    FeedOffer,
    AlertPlusMinusButton,
    PreviewCompanyInPanel,
    OfferWhatsAppLink,
    PhoneCallButton,
    AlertDoneButton
  }
}
</script>
<style scoped>
  .operations {
    max-width: 170px;
    flex-flow: wrap;
  }
</style>
